<!-- <app-header *ngIf="showGuideDetails"></app-header> -->
<div class="guide-container mat-elevation-z4">
    <div class="header">
      <h2><mat-icon>book_open</mat-icon>{{'GUIDES.TITLE_SECTION' | translate}}</h2>
      <p class="subtitle">Unlock everything you need to know to prepare, apply, and succeed.</p>
    </div>
  
    <mat-divider></mat-divider>
  
    <div class="guide-content">
      <h3><mat-icon>list</mat-icon>{{'GUIDES.SUBTITLE_1' | translate}}</h3>

      <div class="flex-row">
        <app-image-portrait *ngIf="pdfInfo.imageUrl" [image]="pdfInfo.imageUrl"></app-image-portrait>
        <ul>
            <li><mat-icon>check_circle</mat-icon> Visa Process and Required Documents</li>
            <li><mat-icon>check_circle</mat-icon> Choosing the Right University and Program</li>
            <li><mat-icon>check_circle</mat-icon> Finding Accommodation and Budget Tips</li>
            <li><mat-icon>check_circle</mat-icon> Legal Rights and Student Benefits</li>
            <li><mat-icon>check_circle</mat-icon> Health Insurance and Safety Tips</li>
          </ul>
        
      </div>
      
      <div class="price-section">
        <span *ngIf="status == 'unpaid'">
            <h4>{{'SHOPPING.PRICE' | translate}}: <span class="price-tag">€14.99</span></h4>
            <p class="note">Includes lifetime access, downloadable PDF, and updates for free.</p>
        </span>
        
        <!-- BUY -->
        <button *ngIf="status == 'unpaid'" mat-button class="button button-fill color-action button-round">
          <mat-icon>shopping_cart</mat-icon>
          {{'GUIDES.BUY_GUIDE' | translate}}
        </button>

        <!-- PAID -->
        <div *ngIf="status == 'paid'">
            <!-- VIEW -->
            <button (click)="openPdf()" mat-button class="button button-fill color-light button-round">
                <mat-icon>eye</mat-icon>
                {{'GUIDES.VIEW_GUIDE' | translate}}
            </button>
            <!-- DOWNLOAD -->
            <button *ngIf="showDownloadButton()" mat-button type="submit" (click)="downloadGuide()" class="button button-fill color-action button-round">
                <span >{{'BUTTONS.DOWNLOAD' | translate}}</span>
            </button>
        </div>

      </div>
    </div>
  
    <mat-divider *ngIf="status == 'unpaid'"></mat-divider>
  
    <div *ngIf="status == 'unpaid'" class="guarantee">
      <mat-icon>shield</mat-icon>
      <span>Secure payment · Instant access · Satisfaction guaranteed</span>
    </div>
</div>
